export default class PreloaderService {
    constructor(selector) {
        this.element = document.querySelector(selector);
        this.preloader = document.createElement('div');
        this.preloader.classList.add('preloader');
        this.preloader.innerHTML = `<div class="perla-loader"></div>`;
    }
    show() {
        if (!this.element) {
            return;
        }
        try {
            this.element.classList.add('preloader-container');
            this.element.appendChild(this.preloader);
        }
        catch (e) {
            console.error(e);
        }
    }
    hide() {
        if (!this.element) {
            return;
        }
        try {
            this.element.classList.remove('preloader-container');
            if (this.preloader.parentElement === this.element) {
                this.element.removeChild(this.preloader);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
}
